import Axios from 'axios'
import Vue from 'vue'
import hxMd5 from 'js-md5'
import configData from './conf'
import { SortParams } from './util'

// 对象键排序函数，确保签名一致性
const sortObjectKeys = (obj) => {
  if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
    return obj
  }
  
  const sortedKeys = Object.keys(obj).sort()
  const sortedObj = {}
  
  sortedKeys.forEach(key => {
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      sortedObj[key] = sortObjectKeys(obj[key]) // 递归处理嵌套对象
    } else {
      sortedObj[key] = obj[key]
    }
  })
  
  return sortedObj
}
let { HTTPURL } = configData
// 设置baseURL
let baseURL = HTTPURL
let reg = RegExp(/api/)
let newAppSecret = ''
let  appSecret = 'u4NciHhVoov/LWvrO5BOKg=='  //加密串  https://activity.xdf.cn
let  appId = 'wechat_app'
let  appSecretCapi = '14e1b600b1fd579f47433b88e8d85291'  //加密串  https://capi.xdf.cn
let  appIdCapi = 'api_app_wechat'
const RESULTCODE = 1

Axios.defaults.withCredentials = true

class httpRequest {
  constructor () {
    this.options = {
      method: '',
      url: ''
    }
    // 存储请求队列
    this.queue = {}
  }
  // 销毁请求实例
  destroy (url) {
    delete this.queue[url]
    const queue = Object.keys(this.queue)
    return queue.length
  }
  // 请求拦截
  interceptors (instance, url, options) {
    // console.log('请求拦截之前', url, options)
    // 添加请求拦截器
    instance.interceptors.request.use(
        // 在发送请求之前做些什么
      config => {
        // config.headers['Content-Type'] = 'application/json; charset=utf-8'
// 
        // 网报接口不验签
        if (options.url.indexOf('/web_reg_uapi/') > -1) {
          return config
        }

        if (url == '/common/check/marketing/wx' || url == '/common/check/wx'||url == '/api/preferential/precomputation/class-simple') {
          config.headers['appId'] = appIdCapi
          newAppSecret = appSecretCapi
        } else {
          config.headers['appId'] = appId
          newAppSecret = appSecret
        }

        if (options.method === 'POST') {
          console.log('options.data', options.data)
          // 对 POST 数据进行排序以确保签名一致性
          const sortedData = sortObjectKeys(options.data)
          
          // 直接使用原始数据，不进行格式转换，让浏览器自动处理
          // config.data 保持为原始的 options.data
          console.log('sortedData', decodeURI(`${JSON.stringify(sortedData)}${newAppSecret}`))
          console.log('hxMd5sortedData', hxMd5(decodeURI(`${JSON.stringify(sortedData)}${newAppSecret}`)))
          
          config.headers['sign'] = hxMd5(decodeURI(`${JSON.stringify(sortedData)}${newAppSecret}`))
        } else {
          let dataStr = options.url + '?' + SortParams(options.params)
          config.headers['sign'] = hxMd5(decodeURI(`${dataStr}${newAppSecret}`))
        }
        return config
      },
      error => {
        // 对请求错误做些什么
        return Promise.reject(error)
      }
    )
    // 添加响应拦截器
    instance.interceptors.response.use(
      res => {
        let { data } = res
        const is = this.destroy(url)
        if (!is) {
          setTimeout(() => {
            // Spin.hide()
          }, 500)
        }
        // 错误状态码处理
        if (Number(data.code) !== RESULTCODE && res.config.url.url === '/web/channel/add') {
          if (res.config.url.match(reg)) {
            if (Number(data.code) === 88888) {
              Vue.$toast(res.data.msg)
            }
          }else {
            Vue.$toast(`请求异常${data.message}`)
          }
          return false
        }
        return data
      },
      error => {
        // console.log(`error ____  ${error}`)
        // if (process.client) alert('信号好像飞到了外太空~')
        // 对响应错误做点什么
        return Promise.reject(new Error(error))
      }
    )
  }
  // 创建实例
  create (options) {
    console.log('create', options)
    let conf = {
      baseURL: baseURL,
      timeout: 30000,
      withCredentials: true
    }
    // console.log('匹配一下是什么', options)
    // if (options.params && options.params.id && options.params.id === 1) {
    //   conf.baseURL = 'http://10.73.32.157:8080'
    // }

    if (options.method === 'POST') {
      conf.data = options.data
    } else if (options.method === 'GET') {
      console.log('conf', conf)
      conf.params = options.params
    }
    // console.log('到底是什么方法*****', options.url, options.method, options.params)
    return Axios.create(conf)
  }
  // 合并请求实例
  // mergeReqest (instances = []) {
  // }
  // 请求实例
  request (options) {
    console.log(options)
    var instance = this.create(options)
    this.interceptors(instance, options.url, options)
    options = Object.assign({}, options)
    this.queue[options.url] = instance
    return instance(options)
  }
}
export default httpRequest
